var CurrentUser = require("lib/account/CurrentUser");

var SmartBookSearch = require("components/reading/books/SmartBookSearch");
var Modal = require("components/utility/AltModal");

require("reading/books/book_search_modal.scss");

class BookSearchModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	show() {
		LuckyOrangeClient.tagComponent("BookSearchModal");
		this.refs.modal.show();
	}

	hide() {
		this.refs.modal.hide();
	}

	render() {

		if (CurrentUser.isStudent()) {
			var userID = CurrentUser.get().id;
		}

		return (
			<Modal className="bookSearchModal" ref="modal" headerText="Find Your Book!">
				<SmartBookSearch onBookSelect={ this.props.onBookSelect } userID={ userID } />

				{ this.props.children }
			</Modal>
		);
	}
};

BookSearchModal.propTypes = StrictPropTypes({
	onBookSelect: PropTypes.func.isRequired,

	// Children are optional, are shown below the search bar
	children: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	]),

});

module.exports = BookSearchModal;



// WEBPACK FOOTER //
// ./modules/components/reading/books/BookSearchModal.js